<template>
  <div>
    <AdminNavbar />
    <SideDrawer />
    <div>
      <div :class="getSideDrawer ? 'content-area' : 'content-area-extend'">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/components/AdminNav.vue";
import SideDrawer from "@/components/SideDrawer.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AdminNavbar,
    SideDrawer
  },
  computed: {
    ...mapGetters({
      getSideDrawer: "getSideDrawer"
    })
  }
};
</script>
<style scoped>
.content-area {
  width: calc(100% - 280px);
  margin-left: 280px;
  min-height: 100vh;
  padding-top: 100px;
  padding-left: 10px;
  padding-right: 10px;
  transition: all 0.3s ease;
}
.content-area-extend {
  width: calc(100% - 75px);
  margin-left: 75px;
  min-height: 100vh;
  padding-top: 100px;
  padding-left: 10px;
  padding-right: 10px;
  transition: all 0.3s ease;
}
@media screen and (max-width: 750px) {
  .content-area,
  .content-area-extend {
    width: 100%;
    margin-left: 0;
  }
}
</style>
